<template>
  <div>
    <page-content>
      <form @submit.prevent="onSubmit()">
        <ntm-block>
          <formly-form :form="form" :model="model" :fields="dataFields"></formly-form>
          <button class="btn btn-success push-15">{{ $t('save') }}</button>
        </ntm-block>
      </form>
    </page-content>
  </div>
</template>

<script>
import SettingsService from '../../services/settings.service'
import formDefinition from './formDefinition'
import UserService from '@/services/user.service'
import store from '@/store'

export default {
  data () {
    return {
      model: {},
      form: {}
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    dataFields () {
      return formDefinition.dataFields.filter(field => {
        if (field.key === 'googleAnalyticsId') {
          return this.user?.isSuperAdmin
        }
        return true
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    SettingsService.index().then((response) => {
      next(vm => vm.setData(response.data))
    })
  },
  methods: {
    setData (data) {
      this.model = data
    },
    onSubmit () {
      SettingsService.storeWebsiteMeta(this.model).then(async () => {
        await UserService.getUser().then((response) => {
          store.commit('currentUser', response.data)
        })
        this.form.$errors = {}
        await this.$store.dispatch('getClient')
        this.$store.commit('loaded')
      }).catch((err) => {
        this.form.$errors = err.response.data.errors
      })
    }
  }
}
</script>
